// 线上环境为 prod, 测试环境为 test
export default {
  driveAPI: 'prod',
  shouleiAPI: 'prod',
  captchaApi: 'prod',
  SL_API: 'prod',
  noteAPI: 'prod',
  appid: 165,
  slAppid: 40,
  iosAudioAppid: 80,
  slAppname: 'android',
  staticHost: 'https://static-xl.a.88cdn.com',
}
